// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"425":"fb166cb3cde93150","4445":"5c3c494a79788e24","7331":"bb316c81c50a5d4c"}[chunkId] + ".css";
};